/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface TechLogsValidationData
 */
export interface TechLogsValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof TechLogsValidationData
     */
    correlationId?: ValidationMessage;
}

export function TechLogsValidationDataFromJSON(json: any): TechLogsValidationData {
    return TechLogsValidationDataFromJSONTyped(json, false);
}

export function TechLogsValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TechLogsValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correlationId': !exists(json, 'correlationId') ? undefined : ValidationMessageFromJSON(json['correlationId']),
    };
}

export function TechLogsValidationDataToJSON(value?: TechLogsValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correlationId': ValidationMessageToJSON(value.correlationId),
    };
}


